<template>
    <div class="goTop" :class="{ madeTop: !showTopBtn }">
        <div class="wxBtn">
            <div class="wxErweimaBox">
                <img src="@/assets/img/kefu.jpg" class="erweima" alt="" />
            </div>
        </div>
        <div class="kfBtn"></div>
        <div class="topBtn" v-show="showTopBtn" @click="goTopFun"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'goTop',
    data() {
        return {
            showTopBtn: true,
        }
    },
    computed: {
        ...mapState(['configInfo']),
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(newV) {
                if (newV == '/product-made') {
                    this.showTopBtn = false
                } else {
                    this.showTopBtn = true
                }
            },
        },
    },
    methods: {
        goTopFun() {
            if (this.mix_isH5()) {
                document.getElementById('app-wrap').scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth', // 可选，平滑滚动效果
                })
            } else {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth', // 可选，平滑滚动效果
                })
            }
        },
    },
}
</script>

<style lang="less" scoped>
.goTop {
    position: fixed;
    right: 0;
    top: 80%;
    transform: translateY(-50%);
    width: 70px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;

    &.madeTop {
        top: 400px;
    }

    .wxBtn {
        width: 70px;
        height: 70px;
        border-radius: 15px 15px 15px 15px;
        background: url('../../assets/img/goTop/wx.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        position: relative;
        margin-bottom: 4px;

        .wxErweimaBox {
            width: 250px;
            background: #ffffff;
            border-radius: 5px 5px 5px 5px;
            display: none;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0%;
            // transform: translateY(-50%);
            left: -250px;

            .erweima {
                width: 220px;
            }
        }

        &:hover {
            background: url('../../assets/img/goTop/wx2.png') no-repeat;
            background-size: 100% 100%;

            .wxErweimaBox {
                display: flex;

                &:hover {
                    display: flex;
                }
            }
        }
    }

    .kfBtn {
        width: 70px;
        height: 70px;
        border-radius: 15px 15px 15px 15px;
        background: url('../../assets/img/goTop/kf.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        margin-bottom: 4px;

        &:hover {
            background: url('../../assets/img/goTop/kf2.png') no-repeat;
            background-size: 100% 100%;
        }
    }

    .topBtn {
        width: 70px;
        height: 70px;
        border-radius: 15px 15px 15px 15px;
        background: url('../../assets/img/goTop/top.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        margin-bottom: 4px;

        &:hover {
            background: url('../../assets/img/goTop/top2.png') no-repeat;
            background-size: 100% 100%;
        }
    }
}
@media screen and (max-width: 1024px) {
    .goTop {
        position: fixed;
        z-index: 999;
        right: 0;
        top: 65%;
        transform: translateY(-50%);
        width: 35px;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;

        &.madeTop {
            top: 400px;
        }

        .wxBtn {
            width: 35px;
            height: 35px;
            border-radius: 15px 15px 15px 15px;
            background: url('../../assets/img/goTop/wx.png') no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            position: relative;
            margin-bottom: 4px;

            .wxErweimaBox {
                width: auto;
                background: #ffffff;
                border-radius: 5px 5px 5px 5px;
                display: none;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0%;
                // transform: translateY(-50%);
                left: -200px;

                .erweima {
                    width: 180px;
                }
            }

            &:hover {
                background: url('../../assets/img/goTop/wx2.png') no-repeat;
                background-size: 100% 100%;

                .wxErweimaBox {
                    display: flex;

                    &:hover {
                        display: flex;
                    }
                }
            }
        }

        .kfBtn {
            width: 35px;
            height: 35px;
            border-radius: 15px 15px 15px 15px;
            background: url('../../assets/img/goTop/kf.png') no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            margin-bottom: 4px;

            &:hover {
                background: url('../../assets/img/goTop/kf2.png') no-repeat;
                background-size: 100% 100%;
            }
        }

        .topBtn {
            width: 35px;
            height: 35px;
            border-radius: 15px 15px 15px 15px;
            background: url('../../assets/img/goTop/top.png') no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            margin-bottom: 4px;

            &:hover {
                background: url('../../assets/img/goTop/top2.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }
}
</style>
